import { Injectable } from '@angular/core';
import {Headers, Http} from '@angular/http';
import {ConnectionService} from "./connection.service";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {Resource} from "../entities/Resource";
import {AppConfig} from "../app.config";
import {Responsible} from "../entities/SalesPerson";

@Injectable()
export class SalesPersonService {
  apiUrl: string;

  headers(company : string = null) : Headers {
    return this.connectionService.GetAuthorizationHeader(company);
  }


  constructor(private http: Http, private connectionService: ConnectionService, private config : AppConfig) {
    this.apiUrl = config.getConfig('endPointApiUrl') + 'api/SalesPerson';
  }

  getSalesPerson(): Observable<Responsible[]> {
    return this.http
      .get(this.apiUrl , {headers: this.headers()})
      .map(response => response.json() as Responsible[]);
  }


  getAllSalesPersons(): Observable<Resource[]> {
    return this.http
      .get(this.apiUrl, {headers: this.headers()})
      .map(response => response.json() as Resource[]);
  }


  getIsEplannerAdmin(no : string) : Observable<boolean> {
    return this.http
      .get(this.apiUrl + '/GetIsEplannerAdmin/' + no, {headers: this.headers()})
      .map(response => response.json() as boolean);

  }

  getAllSalesPersonsAsSalesPerson(company : string = null): Observable<Responsible[]> {
    return this.http
      .get(this.apiUrl, {headers: this.headers(company)})
      .map(response => response.json() as Responsible[]);
  }

  updateSalesPerson(salesPerson: Responsible): Observable<any> {
    return this.http.put(this.apiUrl + '/update', salesPerson,{headers: this.headers()})
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/sales-person.service.ts